import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import disclaimerStyles from './disclaimer.styles' // eslint-disable-line
// TODO fix:@dxp-module/guidance/style-rules

type DisclaimerValueProps = {
  description: string
}

const DisclaimerValue: FC<DisclaimerValueProps> = ({ description }) => {
  const styles = disclaimerStyles()

  return (
    <Box mb={2}>
      <Typography
        component="span"
        variant="caption"
        className={styles.disclaimerText}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </Box>
  )
}

export default DisclaimerValue
